import { createGlobalStyle } from "styled-components";
import bolinhas from "assets/images/bolinhas.svg";

export const GlobalStyle = createGlobalStyle`
	* {
		padding: 0;
		margin: 0;
		/* outline: none; */
		box-sizing: border-box;
    font-family: Poppins, sans-serif;
	}
  
	html, body, #root {
    width: 100%;  
    line-height: 1.875rem;
    background-color: ${({ theme }) => theme.colors.page_background};
    background-image: url(${bolinhas}) ;
    background-repeat: no-repeat;
    background-position: bottom left;
    background-attachment: fixed;
  }

  ul {
    list-style: none;
	}

	a {
		text-decoration: none;
    color:  ${({ theme }) => theme.colors.dark_background};
	}

	button, a {
		cursor: pointer;
		background-color: transparent;
		border: 0;
	}

  label {
    font-size: 0.875rem;
  }

  .grid-1 {
    grid-template-columns: 1fr;
    gap: 1.6rem;
    width: 100%;
  }

  .grid-2 {
    grid-template-columns: 1fr 1fr;
  }

  .grid-3 {
    grid-template-columns: 1fr 1fr 1fr;
  }

  .grid-4 {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }

  .grid-1, .grid-2, .grid-3, .grid-4 {
    display: grid;
    gap: 1.6rem;
    margin-bottom: 0.8rem;
    width: 100%;
  }


  @media (max-width: 991px) {
    .grid-1,
    .grid-2,
    .grid-3,
    .grid-4 {
      display: grid;
      grid-template-columns: 1fr;
      margin-bottom: 0.8rem;
    }
  }


  @media (max-width: ${({ theme }) => theme.breakpoints.medium}) {
    html {
      font-size: 80% !important;
    }
  }


`;
